import React, { useState, useEffect } from "react";
import styles from "./quiz.m.css";
import { fetchLeaderBoard } from "../../../api";
import { get } from "lodash";
import PropTypes from "prop-types";

const sign = require("jwt-encode");

function Leaderboard({ userId, jwtKey, quizType }) {
  const [entries, setEntries] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [ShowBanner, setShowBanner] = useState("");

  function generateJWT(payload) {
    return sign(payload, jwtKey);
  }

  useEffect(
    () => {
      if (!quizType) return;
      setIsLoading(true);
      setError(null);

      const token = generateJWT({ userId });

      fetchLeaderBoard(token, userId, quizType)
        .then(res => {
          const topUsers = get(res, ["data", "data", "top_users"], []);
          const Banner = get(res, ["data", "leaderboard_banner", "desktop"], "");
          setEntries(topUsers);
          setShowBanner(Banner);
        })
        .catch(err => setError(err.message))
        .finally(() => setIsLoading(false));
    },
    [quizType, userId]
  );

  return (
    <div className={styles["leaderboard"]}>
      <div className={styles["leaderboard-header"]}>
        {ShowBanner && (
          <div>
            <img src={`${ShowBanner}?format=webp&w=500&dpr=1.0`} />
          </div>
        )}
        {/* <h2 className={styles["leaderboard__title"]}>LEADER BOARD</h2>
        <div>
          <img src="https://media.vikatan.com/vikatan/2023-10/aa815208-4e9c-4aef-8974-1d7d6646cc2e/sports_vikatan.png?format=webp&w=120&dpr=1.0" />
        </div> */}
      </div>

      <div className={styles["leaderboard-content"]}>
        <div className={styles["leaderboard__header"]}>
          <span>Username</span>
          <span>Email ID / Mobile</span>
        </div>

        <div className={styles["leaderboard__list"]}>
          {isLoading && <p className={styles["leaderboard__status"]}>loading...</p>}
          {error && <p className={styles["leaderboard__status"]}>Error: {error}</p>}
          {!isLoading &&
            !error &&
            entries.map(entry => (
              <div key={entry.rank} className={styles["leaderboard__row"]}>
                <span className={styles["leaderboard__name"]}>{entry.name}</span>
                <span className={styles["leaderboard__email"]}>{entry.email_id}</span>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}

export default Leaderboard;

Leaderboard.propTypes = {
  userId: PropTypes.string,
  jwtKey: PropTypes.string,
  quizType: PropTypes.string
};
